<template>
  <div class="login-card">
    <div class="inputs">
      <div class="login-title">
        登录/注册
      </div>
      <cell-group class="cells">
        <field
            v-model="username"
            clearable
            type="tel"
            label="手机号"
            :readonly="readOnlyTel"
            :error-message="errPhoneMsg"
            placeholder="请输入手机号"></field>
        <field
            v-model="sms"
            center
            clearable
            label="短信验证码"
            placeholder="输入短信验证码"
            v-if="showSms">

          <template #button>
            <Button size="small"
                    :disabled="sendSmsBtnDisabled"
                    type="warning"
                    @click="onClickSendSms"
            >{{smsSendBtnText}}</Button>
          </template>
        </field>
      </cell-group>
      <div class="btn-container">
        <Button type="warning"
                class="btn-login"
                size="small"
                v-if="showSendSmsBtn"
                :loading="isLoadingSendSmsBtn"
                @click="onClickSendSms">发送验证码
        </Button>

        <Button type="warning"
                class="btn-login"
                size="small"
                v-if="showLoginBtn"
                :loading="isLoadingLogin"
                @click="onLogin">登录
        </Button>
      </div>
    </div>

    <div class="wx-account" @click="OnWxLogin">
      <img src="https://a1.wanwanshequ.com/static/public/weixin_icon_thumb.png">
      <div>微信登录</div>
    </div>

    <Popup v-model="showWxLoginCard" class="wx-login-container" :close-on-click-overlay="false"
           :close-on-popstate="true" closeable>
      <div v-if="!isLoadingQr" class="login-qr-img-container">
        <div class="login-title">请用微信扫码登录</div>
        <img :src="qr_url"/>
        <div class="tip">先截屏 <icon-svg icon-class="arrow-right"></icon-svg> 打开微信扫一扫  <icon-svg icon-class="arrow-right"></icon-svg>选择相册二维码</div>
      </div>
      <div v-else>
        <Loading size="24px">正在登录...</Loading>
      </div>
    </Popup>
  </div>
</template>

<script>

  import {Popup, NavBar, Icon, Notify, Loading, Button, CellGroup, Cell, Field, Tabs, Tab, Toast} from 'vant';

  export default {
    name: "LoginCard",
    components: {Notify, NavBar, Button, Cell, CellGroup, Field, Tabs, Tab, Toast, Icon, Popup, Loading},
    props: {
    },
    data() {
      return {
        username: "",
        qr_url: "",
        ak: "",

        errPhoneMsg: "",
        sms: "",
        readOnlyTel: false,
        showSms: false,
        showPassword: false,

        showSendSmsBtn: true,
        showLoginBtn: false,

        isLoadingSendSmsBtn: false,
        isLoadingLogin: false,

        showWxLoginCard: false,
        isLoadingQr: false,

        countDownSms: 0,
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
      },

      startTimer(timeout) {
        if (timeout) {
          this.countDownSms = timeout
        }
        let resendTimer = setInterval(()=> {
          if(this.countDownSms <= 0){
            clearInterval(resendTimer);
            this.countDownSms = 0
          } else {
            this.countDownSms -= 1;
          }
        }, 1000);
      },

      async onClickSendSms() {
        if (!this.checkPhone(this.username)) {
          this.errPhoneMsg = "手机号码格式有误"
          return
        }

        this.isLoadingSendSmsBtn = true
        let params = {
          "tel": this.username,
        }
        await this.$store.dispatch("SendSms", params).then((data)=> {
          if (data.code === 0) {
            this.showSendSmsBtn = false
            this.showLoginBtn = true
            this.showSms = true
            this.readOnlyTel = true
            this.startTimer(data.data.count_down)
          } else {
            Toast("发送失败 请30s后重试！")
          }
        }, (err)=> {
          Toast("网络错误")
        })
        this.isLoadingSendSmsBtn = false
      },

      checkPhone(phoneNumber){
        if(!(/^1[3456789]\d{9}$/.test(phoneNumber))){
          return false;
        }
        return true
      },

      // 登录成功回调
      onLoginSuccess() {
        this.$emit("loginSuccess")
      },

      async onLogin() {
        if (!this.sms || !this.username) {
          Toast("输入格式错误")
          return
        }
        let params = {
          name: this.username,
          sms: this.sms
        }
        this.isLoadingLogin = true
        await this.$store.dispatch("LoginSms", params).then((data)=> {
          if (data.code === 0) {
            this.onLoginSuccess()
          } else if (data.code === 60001) {
            Toast("验证码错误")
          }
        }, ()=> {
        })
        this.isLoadingLogin = false
      },

      async OnWxLogin() {
        this.showWxLoginCard = true
        this.isLoadingQr = true

        // 检查当前状态是否已登录
        // 未登录状态
        let ak = this.$store.getters.getAkWxLogin
        let params = {}
        if (ak) {
          params.ak = ak
        }
        await this.$store.dispatch("WxOauthLoginCode", params).then((data) => {
          if (data.code === 0) {
            this.qr_url = data.data.url
            this.ak = data.data.ak
            this.$store.dispatch("SetAkWxLogin", this.ak)
            if (data.data.status === 4) {
              Toast("登录成功")
              this.onLoginSuccess()
              this.$store.dispatch("SetAkWxLogin", "")
              this.showWxLoginCard = false
            }
          } else if (data.code === 20005) {
            this.showWxLoginCard = false
            Toast("当前已登录")
            this.onLoginSuccess()
          }
        }, () => {
          Toast("系统错误")
        })
        this.isLoadingQr = false
      },

      startCheckLogin() {
        this.checkMethod = setInterval(() => {
          if (this.ak) {
            let params = {
              "ak": this.ak,
            }
            this.$store.dispatch("OauthLoginStatus", params).then((data) => {
              if (data.code === 0) {
                if (data.data.status === 4) {
                  this.$store.dispatch("SetAkWxLogin", "")
                  this.showWxLoginCard = false
                  Toast("登录成功")
                  this.onLoginSuccess()
                }
              } else if (data.code === 20005) {
                this.showWxLoginCard = false
                Toast("当前已登录")
                this.onLoginSuccess()
              } else {
              }
            }, () => {
            })
          }
        }, 2000);
      },

      stopCheckLogin() {
        if (this.checkMethod) {
          clearInterval(this.checkMethod)
        }
      }
    },
    watch: {
      showWxLoginCard(newVal, oldVal) {
        if (this.showWxLoginCard) {
          this.startCheckLogin()
        } else {
          this.stopCheckLogin()
        }
      },

      username() {
        this.errPhoneMsg = ""
      }
    },

    computed: {
      smsSendBtnText() {
        if (this.countDownSms > 0) {
          return `发送验证码(${this.countDownSms})`
        } else {
          return  "发送验证码"
        }
      },
      sendSmsBtnDisabled() {
        if (this.countDownSms > 0) {
          return true
        } else {
          return false
        }
      }
    },

    deactivated() {
      this.stopCheckLogin()
    },

    beforeDestroy() {
      this.stopCheckLogin()
    }

  };
</script>

<style lang="scss" scoped>
  .login-card {
    padding: 12px 0;
    width: 100%;
    color: #666;
  }

  .btn-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;

    .btn-login {
      padding: 18px 0;
      width: 100%;
    }
  }

  .inputs {
    padding: 5px 15px;

    .login-title {
      color: #222;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
    }
  }

  .cells {
    margin-top: 15px;
  }

  .wx-account {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 18px;

    img {
      width: 30px;
      margin: 0 5px;
    }
  }

  .wx-login-container {
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 25px 10px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }

  .login-qr-img-container {
    min-height: 40vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .login-title {
      font-size: 18px;
      padding: 5px 0;
      font-weight: bold;
    }

    img {
      width: 60%;
    }

    .tip {
      margin-top: 15px;
      font-size: 12px;
    }
  }

  .empty-cell {
    padding-bottom: 50px;
  }
</style>
